import { Injectable } from '@angular/core';
import {
  ApiResponseOfDeliveryNoteReplyDto,
  ApiResponseOfDownloadReportDto,
  ApiResponseOfIEnumerableOfDeliveryNoteReplyDto,
  ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto,
  ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto,
  ApiSortDirection,
  DeliveryNoteReplyDto,
  DeliveryNoteReplyUpdateDto,
  FileResponse,
  IDeliveryNoteReplyApiService,
} from '@api';
import { CrudBase } from '@app/mock/models';
import { DELIVERY_NOTE_REPLIES } from '@app/mock/data/delivery-note-replies';
import { Observable, of } from 'rxjs';

@Injectable()
export class DeliveryNoteReplyApiMockService extends CrudBase<DeliveryNoteReplyDto> implements IDeliveryNoteReplyApiService {
  constructor() {
    super(DELIVERY_NOTE_REPLIES);
  }

  getPagedDeliveryNoteReplies(
    skip?: number | undefined,
    take?: number | undefined,
    filterName?: string[] | null | undefined,
    filterValue?: string | null | undefined,
    sortName?: string[] | null | undefined,
    sortDirection?: ApiSortDirection | undefined
  ): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto> {
    return this.getRange(skip, take, filterName, filterValue, sortName, sortDirection);
  }

  getDeliveryNoteReply(id: number): Observable<ApiResponseOfDeliveryNoteReplyDto> {
    return this.get(id);
  }

  createDeliveryNoteReply(dto: DeliveryNoteReplyDto): Observable<ApiResponseOfDeliveryNoteReplyDto> {
    return this.create(dto);
  }

  updateDeliveryNoteReply(updateDto: DeliveryNoteReplyUpdateDto): Observable<ApiResponseOfDeliveryNoteReplyDto> {
    throw new Error('Method not implemented.');
  }

  deleteDeliveryNoteReply(id: number): Observable<ApiResponseOfDeliveryNoteReplyDto> {
    return this.delete(id);
  }

  deleteBulkDeliveryNoteReplies(ids?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto> {
    return this.deleteBulk(ids ?? []);
  }

  getNewForDeliveryNote(remoteAccessToken?: string | undefined): Observable<ApiResponseOfDeliveryNoteReplyDto> {
    throw new Error('Method not implemented.');
  }

  getDeliveryDatesOfRepliesForDeliveryNote(remoteAccessToken?: string | undefined): Observable<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto> {
    throw new Error('Method not implemented.');
  }

  loadByDeliveryNote(
    deliveryNoteId?: number | undefined,
    filterName?: string[] | null | undefined,
    filterValue?: string | null | undefined,
    sortName?: string[] | null | undefined,
    sortDirection?: ApiSortDirection | undefined
  ): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto> {
    const items = DELIVERY_NOTE_REPLIES.filter((r) => r.deliveryNoteId === deliveryNoteId);
    return of(this.createApiResponse(items));
  }

  updateDeliveryNoteReplyStatus(id: number, newStatusId?: number | undefined): Observable<ApiResponseOfDeliveryNoteReplyDto> {
    throw new Error('Method not implemented.');
  }

  requestReportDownload(deliveryNoteReplyId: number): Observable<ApiResponseOfDownloadReportDto> {
    throw new Error('Method not implemented.');
  }

  downloadReport(token?: string | undefined): Observable<FileResponse> {
    throw new Error('Method not implemented.');
  }

  getOpenDeliveryNoteRepliesByDeliveryNoteId(deliveryNoteId: number): Observable<DeliveryNoteReplyDto[]> {
    throw new Error('Method not implemented.');
  }
}
